<template>
  <section>
    <frm-libro-atencion
      :is-toggle-sidebar-atencion.sync="isToggleSidebarAtencion"
      :data-edit="dataEdit"
      @refetch-data="refetchData"
      @error-data="showError"
    />
    <b-card
      no-body
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrando</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="pageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
            <!-- <b-button
              variant="primary"
            >
              Exportar
            </b-button> -->
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="query"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <flat-pickr
                id="fecha"
                v-model="fechaFilter"
                class="form-control"
                :config="configDP"
                placeholder="Seleccione Fecha"
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refListTable"
        :items="items"
        responsive
        :fields="fields"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No se encontraron registros"
        class="position-relative"
        :busy="isBusy"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner
              variant="primary"
              class="align-middle"
            />
            <strong class="ml-1">Cargando...</strong>
          </div>
        </template>
        <template #cell(nombresApellidos)="data">
          <div class="d-flex align-items-center">
            <div>
              <div class="font-weight-bold font-small-3">
                {{ data.item.nombresApellidos }}
              </div>
              <div class="font-small-3">
                <b>{{ data.item.tipoDocumento }}:</b> {{ data.item.documento }}
              </div>
              <div class="font-small-3">
                <b>Dirección</b> {{ data.item.direccion }}
              </div>
              <div class="font-small-3">
                <b>Correo</b> {{ data.item.email }}
              </div>
              <div class="font-small-3">
                <b>Teléfono</b> {{ data.item.telefono }}
              </div>
            </div>
          </div>
        </template>
        <template #cell(descripcionProducto)="data">
          <div class="d-flex align-items-center">
            <div>
              <div class="font-weight-bold font-small-3">
                {{ data.item.tipoBien }} {{ data.item.descripcionProducto }}
              </div>
              <div class="font-small-3">
                <b>Fecha:</b> {{ data.item.fechaPedido }}
              </div>
              <div class="font-small-3">
                <b>Monto:</b> {{ data.item.montoReclamado }}
              </div>
            </div>
          </div>
        </template>
        <template #cell(detalleReclamo)="data">
          <div class="d-flex align-items-center">
            <div>
              <div class="font-weight-bold d-block text-nowrap">
                Tipo: {{ data.item.tipoReclamo }}
              </div>
              <div class="font-small-3">
                <b>Reclamo:</b> {{ data.item.detalleReclamo }}
              </div>
              <div class="font-small-3">
                <b>Pedido:</b> {{ data.item.infoPedido }}
              </div>
            </div>
          </div>
        </template>

        <template #cell(estadoReclamo)="data">
          <div class="align-items-center">
            <div>
              <b-badge
                pill
                :variant="`light-${data.item.estadoReclamo === 'PENDIENTE' ? 'warning' : 'success'}`"
              >
                {{ data.item.estadoReclamo }}
              </b-badge>
            </div>
          </div>
        </template>

        <template #cell(fechaRegistro)="data">
          <div class="font-small-3 text-justify">
            <b-badge
              pill
              variant="light-dark"
            >
              <b>Registro:</b> {{ formatDateTime(data.item.fechaRegistro) }}
            </b-badge>
          </div>
          <div
            v-if="data.item.fechaAtencion"
            class="font-small-3 text-justify"
          >
            <b-badge
              pill
              variant="light-dark"
              class="mt-50"
            >
              <b>Atención:</b> {{ formatDateTime(data.item.fechaAtencion) }}
            </b-badge>
          </div>
          <div
            v-if="data.item.fechaAtencionRecepcion"
            class="font-small-3 text-justify"
          >
            <b-badge
              pill
              variant="light-dark"
              class="mt-50"
            >
              <b>Confirmación:</b> {{ formatDateTime(data.item.fechaAtencionRecepcion) }}
            </b-badge>
          </div>
        </template>

        <template #cell(acciones)="data">
          <b-button-toolbar justify>
            <b-button-group size="sm">
              <b-button
                v-if="data.item.estadoReclamo === 'PENDIENTE'"
                v-b-tooltip.hover.top="'Descargar PDF del reclamo'"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="info"
                @click="descargarPDF(data.item)"
              >
                <feather-icon icon="DownloadIcon" />
              </b-button>
              <b-button
                v-if="data.item.estadoReclamo === 'ATENDIDO'"
                v-b-tooltip.hover.top="'Descargar PDF del reclamo'"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="info"
                :href="pathDocuments + data.item.evidencia"
                target="_blank"
                @click="data.item.estadoReclamo === 'PENDIENTE' ? descargarPDF(data.item) : null"
              >
                <feather-icon icon="DownloadIcon" />
              </b-button>
              <b-button
                v-if="data.item.estadoReclamo === 'PENDIENTE'"
                v-b-tooltip.hover.top="'Actualizar a Atendido'"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="success"
                @click="updateStatus(data.item)"
              >
                <feather-icon icon="ThumbsUpIcon" />
              </b-button>
            </b-button-group>
          </b-button-toolbar>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ from }} a {{ to }} de {{ of }} registros</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="page"
              :total-rows="totalItems"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </section>

</template>

<script>
// import Vue from 'vue'
import { ref, watch } from '@vue/composition-api'
import {
  BCard, BRow, BCol, BFormInput, BTable, BBadge, BPagination, BSpinner, BButtonToolbar, BButtonGroup, VBTooltip, BButton,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import store from '@/store'
import config from '@/services/config'
import Ripple from 'vue-ripple-directive'
import { formatDateTime } from '@/helpers/dates'
import { generateLibroReclamacionPDF } from '@/helpers/reclamo-pdf'
import { showError } from '@/helpers'
import FrmLibroAtencion from './FrmLibroAtencion.vue'

export default {
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    /* BButton, */
    BTable,
    BBadge,
    BPagination,
    BSpinner,

    vSelect,
    flatPickr,
    BButtonToolbar,
    BButtonGroup,
    BButton,
    FrmLibroAtencion,
  },
  setup() {
    const isBusy = ref(false)
    const items = ref([])
    const fields = ref([
      { key: 'idLibroReclamacion', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'nombresApellidos', label: 'Consumidor', sortable: true },
      { key: 'descripcionProducto', label: 'Bien Contratado', sortable: true },
      { key: 'detalleReclamo', label: 'Mensaje', sortable: true, thClass: 'text-justify, wl-300', tdClass: 'text-justify, wl-300' },
      { key: 'fechaRegistro', label: 'Fechas', sortable: true, thClass: 'text-center', tdClass: 'text-justify' },
      { key: 'estadoReclamo', label: 'Estado', sortable: true, thClass: 'text-center', tdClass: 'text-justify' },
      { key: 'acciones', thClass: 'text-center', tdClass: 'text-center' },
    ])
    const configDP = ref({
      enableTime: false,
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'd/m/Y',
    })
    const page = ref(1)
    const perPage = ref(10)
    const sortBy = ref('idLibroReclamacion%7CDESC')
    const query = ref('')
    const fechaFilter = ref('')
    const totalRows = ref(0)
    const totalItems = ref(0)
    const totalPage = ref(0)
    const from = ref(0)
    const to = ref(0)
    const of = ref(0)
    const pageOptions = ref([10, 20, 50])
    const { baseURL } = config

    const dataEdit = ref(null)
    const isToggleSidebarAtencion = ref(false)
    const pathDocuments = ref(`${config.baseURL}${config.contextApi}/api/v1/public/getPDF/ByUrl?url=`)

    const listarRegistros = async () => {
      isBusy.value = true
      await store.dispatch('portal/FRM_LIBRO_RECLAMACION_FIND_ALL', {
        estadoReclamo: '',
        tipo: 'grilla',
        query: query.value,
        page: page.value,
        limit: perPage.value,
        sortBy: sortBy.value,
        dateFilter: fechaFilter.value,
      })
        .then(response => {
          if (response) {
            items.value = response.items
            totalRows.value = response.totalRows
            totalItems.value = response.totalItems
            totalPage.value = response.totalPage
            from.value = perPage.value * (page.value - 1) + (totalRows.value ? 1 : 0)
            to.value = perPage.value * (page.value - 1) + totalRows.value
            of.value = totalItems.value
          }
        })
      isBusy.value = false
    }

    const descargarPDF = reclamo => {
      generateLibroReclamacionPDF(reclamo)
    }

    const updateStatus = data => {
      dataEdit.value = data
      isToggleSidebarAtencion.value = true
    }

    const refetchData = () => {
      listarRegistros()
    }

    watch([page, perPage, query, fechaFilter], () => {
      listarRegistros()
    })

    listarRegistros()

    return {
      avatarText,
      isBusy,
      sortBy,
      page,
      perPage,
      query,
      items,
      fields,
      fechaFilter,
      listarRegistros,
      totalRows,
      totalItems,
      totalPage,
      from,
      to,
      of,
      pageOptions,
      configDP,
      baseURL,
      formatDateTime,
      updateStatus,
      descargarPDF,
      dataEdit,
      isToggleSidebarAtencion,
      refetchData,
      showError,
      pathDocuments,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
.wl-300 {
  width: 300px !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style>
#swal2-content {
  padding-top: 20px;
  padding-bottom: 10px;
}
.wl-300 {
  width: 300px !important;
}
</style>
